import React from 'react';
import { getPrice } from '../utils/commerce';
export function PriceTag({
  size = 'lg',
  tone = 'light'
}: {
  size?: 'lg' | 'md' | 'sm';
  tone?: 'light' | 'dark';
}) {
  const price = getPrice();
  if (!price) return null;
  const amount = size === 'lg' ? 'text-[52px]' : size === 'md' ? 'text-[34px]' : 'text-[20px]';
  const text = tone === 'light' ? 'text-ink' : 'text-ivory';
  const sub = tone === 'light' ? 'text-inkSoft' : 'text-mist';
  return <p className={`flex items-baseline gap-2 ${text}`} data-id="element-23" data-mp="19v2o6sad813q">
      <span className={`font-display font-bold leading-none ${amount}`} data-id="element-24" data-mp="1eo5nlh1tq4ru">{price.amount}</span>
      <span className={`font-mono text-[13px] uppercase tracking-[0.1em] ${sub}`} data-id="element-25" data-mp="10xa8hn0qerft">{price.currency}</span>
    </p>;
}